var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "#FF4D4D",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_346_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0589 37.7726L42.2281 15.9431C40.9718 14.6856 38.9326 14.6856 37.6747 15.9431L33.1415 20.4763L38.8921 26.2269C40.2285 25.7754 41.7607 26.0783 42.8261 27.1437C43.8965 28.2157 44.1971 29.7611 43.7346 31.102L49.2767 36.6441C50.6175 36.1822 52.1645 36.4812 53.2354 37.5537C54.732 39.0498 54.732 41.4747 53.2354 42.9719C51.7383 44.469 49.3134 44.469 47.8157 42.9719C46.69 41.845 46.4118 40.1915 46.9818 38.8046L41.8134 33.636L41.8128 47.2374C42.1777 47.4184 42.5222 47.6593 42.8261 47.9621C44.3227 49.4582 44.3227 51.8831 42.8261 53.3814C41.329 54.878 38.903 54.878 37.4081 53.3814C35.9115 51.8831 35.9115 49.4582 37.4081 47.9621C37.7778 47.5929 38.2057 47.3136 38.6622 47.126V33.3979C38.2057 33.2114 37.7784 32.9338 37.4081 32.5618C36.2741 31.4295 36.0014 29.7655 36.5824 28.3731L30.9142 22.7037L15.9454 37.6717C14.6875 38.9302 14.6875 40.9694 15.9454 42.2268L37.7762 64.0569C39.033 65.3144 41.0717 65.3144 42.3302 64.0569L64.0589 42.3283C65.3163 41.0704 65.3163 39.03 64.0589 37.7726",
    fill: "#FF4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_346_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/Git.0ed9caa555ec69ea042a0c53560f362a.svg";
export { ForwardRef as ReactComponent };